import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, X, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
interface FeedbackOverlayProps {
  show: boolean;
  isCorrect: boolean;
  correctAnswer?: string | number;
  question?: string;
  onContinue?: () => void;
}
export function FeedbackOverlay({
  show,
  isCorrect,
  correctAnswer,
  question,
  onContinue
}: FeedbackOverlayProps) {
  return <AnimatePresence data-id="element-35">
      {show && <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.9
    }} transition={{
      duration: 0.15
    }} className="fixed inset-0 z-50 flex items-center justify-center bg-black/20 backdrop-blur-sm" data-id="element-36">
          <motion.div initial={{
        y: 20
      }} animate={{
        y: 0
      }} transition={{
        duration: 0.15
      }} className={`rounded-2xl p-8 shadow-2xl max-w-sm mx-4 ${isCorrect ? 'bg-emerald-500 text-white' : 'bg-rose-500 text-white'}`} data-id="element-37">
            <div className="flex flex-col items-center gap-4" data-id="element-38">
              <div className={`w-16 h-16 rounded-full flex items-center justify-center ${isCorrect ? 'bg-emerald-600' : 'bg-rose-600'}`} data-id="element-39">
                {isCorrect ? <Check className="w-10 h-10" strokeWidth={3} data-id="element-40" /> : <X className="w-10 h-10" strokeWidth={3} data-id="element-41" />}
              </div>

              <div className="text-center space-y-3" data-id="element-42">
                <div className="text-2xl font-bold" data-id="element-43">
                  {isCorrect ? 'Correct!' : 'Incorrect'}
                </div>
                {!isCorrect && correctAnswer && question && <div className="text-3xl font-bold opacity-95 bg-white/10 px-4 py-3 rounded-lg" data-id="element-44">
                    {question} = {correctAnswer}
                  </div>}
              </div>

              {!isCorrect && onContinue && <Button onClick={onContinue} variant="secondary" size="lg" className="mt-4 bg-white text-rose-600 hover:bg-white/90" data-id="element-45">
                  Continue <ArrowRight className="w-5 h-5 ml-2" data-id="element-46" />
                </Button>}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}